import {
  GET_ALL_BUSINESSES_REQUEST,
  GET_ALL_BUSINESSES_SUCCESS,
  GET_ALL_BUSINESSES_FAIL,
  ADD_BUSINESS_REQUEST,
  ADD_BUSINESS_SUCCESS,
  ADD_BUSINESS_FAIL,
  GET_BUSINESS_LOG_REQUEST,
  GET_BUSINESS_LOG_SUCCESS,
  GET_BUSINESS_LOG_FAIL,
  ADD_BUSINESS_LOG_REQUEST,
  ADD_BUSINESS_LOG_SUCCESS,
  ADD_BUSINESS_LOG_FAIL,
  DELETE_BUSINESS_LOG_REQUEST,
  DELETE_BUSINESS_LOG_SUCCESS,
  DELETE_BUSINESS_LOG_FAIL
} from "../constants/BusinessConstants";

import BusinessService from "../Services/businessservice";

export const GetAllBusinessesAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_BUSINESSES_REQUEST });

    const { data } = await BusinessService.GetAllBusinesses();

    dispatch({
      type: GET_ALL_BUSINESSES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_BUSINESSES_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const AddBusinessAction = (businessData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_BUSINESS_REQUEST });

    const { data } = await BusinessService.AddBusiness(businessData);

    dispatch({
      type: ADD_BUSINESS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADD_BUSINESS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const GetBusinessInteractionLogAction = (businessId, clientId) => async (dispatch) => {
  try {
    dispatch({ type: GET_BUSINESS_LOG_REQUEST });

    const { data } = await BusinessService.GetBusinessInteractionLog(businessId, clientId);

    dispatch({
      type: GET_BUSINESS_LOG_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_BUSINESS_LOG_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const AddBusinessLogAction = (logData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_BUSINESS_LOG_REQUEST });

    const { data } = await BusinessService.AddBusinessLog(logData);

    dispatch({
      type: ADD_BUSINESS_LOG_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADD_BUSINESS_LOG_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const DeleteBusinessLogAction = (logId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_BUSINESS_LOG_REQUEST });

    const { data } = await BusinessService.DeleteBusinessLog(logId);

    dispatch({
      type: DELETE_BUSINESS_LOG_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DELETE_BUSINESS_LOG_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};